import Vue from 'vue'
import store from '@/store'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'to',
  messages: {}
})

/* const langmessages = {   
  en: {
    create_account: "Create an account",
    login: "Login",
    log_in: "Log in",
    register: "Register",
    email: "Email",
    password: "Password",
    remember_me: "Remember me",
    show_password: "Show password",
    forgot_password: "Forgot your password?",
    reset_password: "Reset Password",
    already_have_account: "Already have an account? Log In",
    no_account: "Don’t have an account? Sign up",
    
    get_started: "Getting started",
    get_started_message: "Because we know you have a long-term condition, we’re checking in during the COVID-19 lockdown to ask a few questions about your health and well-being.",
    next: "Next",
    finish: "Finish",
    yes: "Yes",
    no: "No",
    comments_placeholder: "Leave a message (optional)",
    checking_in: "Checking In",
  },   
  to: {
    create_account: "Fokotu’u ha’o ‘akauni",
    login: "Fakamo’oni ke ke hu ki loto",
    log_in: "Fakamo’oni ke ke hu ki loto",
    register: "Lesisita",
    email: "Email",
    password: "Lea fakapulipuli ke hu ki loto",
    remember_me: "Fakamanatu’i au",
    show_password: "Faka’asi mai e lea fakapulipuli ke hu ki loto",
    forgot_password: "Ngalo ho’o lea fakapulipuli ke hu ki loto?",
    reset_password: "Fetongi e lea fakapulipuli ke hu ki loto",
    already_have_account: "‘Osi ‘i ai ha’o ‘akauni? Fakamo’oni ke ke hu ki loto",
    no_account: "‘Ikai ke ‘i ai ha’o akauni? Fakamo’oni ke ke hu mai",
    
    get_started: "Ko ho’o kamata",
    get_started_message: "Koe’uhi ‘oku mau ‘ilo ‘oku ‘i ai ha puke tauhi fuoloa, ‘oku mau vakai atu ai he taimi fakataputapu ko eni he COVID-19 ke ‘eke atu ha fehu’i si’i pe fekau’aki mo ho’o mo’ui lelei mo vakai pe ‘oku lelei ho’o nofo?",
    next: "Hoko",
    finish: "‘Osi",
    yes: "‘Io",
    no: "‘Ikai",
    comments_placeholder: "Tuku ha fekau (kapau te ke fie tuku)",
    checking_in: "Vakai atu",
  }
} */

/**
 * @param {String} locale
 */
export async function loadMessages (locale) {
  if (Object.keys(i18n.getLocaleMessage(locale)).length === 0) {
    const messages = await import(/* webpackChunkName: '' */ `@/lang/${locale}`)
    i18n.setLocaleMessage(locale, messages)
  }

  if (i18n.locale !== locale) {
    i18n.locale = locale
  }
}

(async function () {
  await loadMessages(store.getters['locale'])
})()

export default i18n


